import React, { useEffect, useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import sessionsService from '../../../services/sessionsServices';
import Toast from '../../Toast';

const RenameChatModal = ({ onClose, data }) => {
  const [title, setTitle] = useState('');
  const queryClient = useQueryClient();

  const handleSubmit = useMutation({
    mutationFn: async () => {
      return await sessionsService?.updateSession({
        platform_id: 'coinpilotlabs',
        session_id: data?.id,
        title,
      });
    },
    retry: 1,
    onSuccess: response => {
      Toast({ type: 'success', message: response.detail });
      queryClient.invalidateQueries({ queryKey: ['sessions'] });
      onClose();
    },
    onError: err => {
      Toast({ type: 'error', message: err.detail });
    },
  });

  useEffect(() => {
    if (data?.title) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = data.title;
      setTitle(tempDiv.innerText.trim());
    }
  }, [data?.title]);

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div
        className="bg-shell-card border border-shell-card-border rounded-xl p-6 w-full max-w-md"
        onClick={e => e.stopPropagation()}>
        <h3 className="text-lg font-semibold text-white mb-4">Edit Chat Title</h3>
        <label className="text-sm text-muted mb-1.5 block">Chat Title</label>
        <input
          value={title}
          onChange={e => setTitle(e.target.value)}
          placeholder="Enter chat title"
          className="w-full bg-shell border border-shell-card-border rounded-lg px-3 py-2 text-sm text-white placeholder:text-muted-faint outline-none focus:border-primary/40"
        />
        <div className="flex justify-end gap-2 mt-6">
          <button type="button" onClick={onClose} className="px-4 py-2 text-sm text-muted hover:text-white">
            Cancel
          </button>
          <button
            type="button"
            onClick={() => handleSubmit.mutate()}
            disabled={!title.trim() || handleSubmit.isPending}
            className="px-4 py-2 text-sm font-medium bg-primary hover:bg-primary/90 text-black rounded-lg disabled:opacity-50">
            {handleSubmit.isPending ? 'Updating...' : 'Update'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RenameChatModal;
